"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getAllThemeIds_1 = require("owa-theme/lib/utils/getAllThemeIds");
// These won't change dynamically during a session
var availableThemeIds;
exports.ThemeIdsToFilter = [];
function getAvailableThemeIds() {
    return (availableThemeIds ||
        (availableThemeIds = getAllThemeIds_1.default().filter(function (themeId) { return exports.ThemeIdsToFilter.indexOf(themeId) === -1; })));
}
exports.default = getAvailableThemeIds;
//# sourceMappingURL=getAvailableThemeIds.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-theme-option/lib/utils/getAvailableThemeIds.js
// module id = 3370
// module chunks = 2